"use strict";

import angular from "angular";

import template from "./special-chart.component.html";
import "./special-chart.component.scss";

import { ComponentsName } from "../../../imports/components";

class SpecialChartComponent {
    constructor($scope, $compile, $element) {
        this.$scope = $scope;
        this.$compile = $compile;
        this.$element = $element;
    }

    $onInit() {
        this._compile();
    }

    _compile() {
        const regex = /\$\$(.*?)/g;
        let html = ComponentsName[this.component.name];
        if (!html) return;

        html = html.replace(regex, "$ctrl.");

        const compiled = this.$compile(html)(this.$scope);
        const element = angular.element(this.$element[0].firstChild);
        element.append(compiled);
    }
}

export { SpecialChartComponent };

SpecialChartComponent.$inject = ["$scope", "$compile", "$element"];

const name = "specialChartComponent";
const def = {
    bindings: {
        component: "<",
        series: "<",
        highlightsSeries: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        historicSeries: "<",
        fakeData: "<",
        refreshData: "&",
        specialConfigs: "<",
        companyData: "<",
        currentFilterGroup: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<",
        goals: "<",
        isReport: "<",
        isAccumulated: "<"
    },
    controller: SpecialChartComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
